// recommend.proto — the actual point of the project.
//
// Recommendations are a weighted blend of independent signals rather than one
// model's opinion. Each signal is individually weak and individually explicable:
// tag-rank overlap knows nothing about quality, the co-recommendation graph is
// dense for popular titles and empty for obscure ones, embeddings capture tone
// but conflate "similar synopsis" with "similar experience". Exposing the
// per-signal contributions in the response is what makes bad results
// debuggable instead of mysterious.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file amrec/v1/recommend.proto (package amrec.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Work } from "./catalog_pb";
import { file_amrec_v1_catalog } from "./catalog_pb";
import type { SearchFilters } from "./search_pb";
import { file_amrec_v1_search } from "./search_pb";
import type { Source } from "./common_pb";
import { file_amrec_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file amrec/v1/recommend.proto.
 */
export const file_amrec_v1_recommend: GenFile = /*@__PURE__*/
  fileDesc("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", [file_amrec_v1_catalog, file_amrec_v1_search, file_amrec_v1_common]);

/**
 * SignalWeights tunes the blend. All default to server config; a request may
 * override any subset, which is how the weights get tuned interactively
 * against the offline eval set instead of by redeploying.
 *
 * @generated from message amrec.v1.SignalWeights
 */
export type SignalWeights = Message<"amrec.v1.SignalWeights"> & {
  /**
   * SignalKind enum name -> weight
   *
   * @generated from field: map<string, double> weights = 1;
   */
  weights: { [key: string]: number };
};

/**
 * Describes the message amrec.v1.SignalWeights.
 * Use `create(SignalWeightsSchema)` to create a new message.
 */
export const SignalWeightsSchema: GenMessage<SignalWeights> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 0);

/**
 * SignalContribution is one scorer's verdict on one candidate.
 *
 * @generated from message amrec.v1.SignalContribution
 */
export type SignalContribution = Message<"amrec.v1.SignalContribution"> & {
  /**
   * @generated from field: amrec.v1.SignalKind kind = 1;
   */
  kind: SignalKind;

  /**
   * scorer-native, 0-1 normalized
   *
   * @generated from field: double raw_score = 2;
   */
  rawScore: number;

  /**
   * raw_score * weight, what actually summed
   *
   * @generated from field: double weighted = 3;
   */
  weighted: number;

  /**
   * Human-readable justification, e.g. "shares 8 tags incl. Time Loop (91%)"
   * or "412 users recommended this after Steins;Gate".
   *
   * @generated from field: string explanation = 4;
   */
  explanation: string;
};

/**
 * Describes the message amrec.v1.SignalContribution.
 * Use `create(SignalContributionSchema)` to create a new message.
 */
export const SignalContributionSchema: GenMessage<SignalContribution> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 1);

/**
 * @generated from message amrec.v1.Recommendation
 */
export type Recommendation = Message<"amrec.v1.Recommendation"> & {
  /**
   * @generated from field: amrec.v1.Work work = 1;
   */
  work?: Work | undefined;

  /**
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * @generated from field: repeated amrec.v1.SignalContribution signals = 3;
   */
  signals: SignalContribution[];
};

/**
 * Describes the message amrec.v1.Recommendation.
 * Use `create(RecommendationSchema)` to create a new message.
 */
export const RecommendationSchema: GenMessage<Recommendation> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 2);

/**
 * @generated from message amrec.v1.RecommendSimilarRequest
 */
export type RecommendSimilarRequest = Message<"amrec.v1.RecommendSimilarRequest"> & {
  /**
   * @generated from field: string work_id = 1;
   */
  workId: string;

  /**
   * @generated from field: amrec.v1.SearchFilters filters = 2;
   */
  filters?: SearchFilters | undefined;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: amrec.v1.SignalWeights weights = 4;
   */
  weights?: SignalWeights | undefined;

  /**
   * Sequels and adaptations of the seed are technically its nearest neighbours
   * and are also the least useful thing to recommend. On by default.
   *
   * @generated from field: bool exclude_related = 5;
   */
  excludeRelated: boolean;

  /**
   * Populate SignalContribution.explanation. Costs extra queries; off for
   * list views, on for a detail page.
   *
   * @generated from field: bool explain = 6;
   */
  explain: boolean;
};

/**
 * Describes the message amrec.v1.RecommendSimilarRequest.
 * Use `create(RecommendSimilarRequestSchema)` to create a new message.
 */
export const RecommendSimilarRequestSchema: GenMessage<RecommendSimilarRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 3);

/**
 * @generated from message amrec.v1.RecommendSimilarResponse
 */
export type RecommendSimilarResponse = Message<"amrec.v1.RecommendSimilarResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.Recommendation recommendations = 1;
   */
  recommendations: Recommendation[];
};

/**
 * Describes the message amrec.v1.RecommendSimilarResponse.
 * Use `create(RecommendSimilarResponseSchema)` to create a new message.
 */
export const RecommendSimilarResponseSchema: GenMessage<RecommendSimilarResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 4);

/**
 * RecommendForUserRequest ranks against an imported list profile. The list
 * importer is built but not yet run, so this returns FAILED_PRECONDITION until
 * a profile exists — deliberately, rather than silently degrading to
 * popularity, which would look like it worked.
 *
 * @generated from message amrec.v1.RecommendForUserRequest
 */
export type RecommendForUserRequest = Message<"amrec.v1.RecommendForUserRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: amrec.v1.SearchFilters filters = 2;
   */
  filters?: SearchFilters | undefined;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: amrec.v1.SignalWeights weights = 4;
   */
  weights?: SignalWeights | undefined;

  /**
   * Exclude anything already on the list in these states. Defaults to
   * completed + dropped + watching — i.e. recommend genuinely new things.
   *
   * @generated from field: repeated string exclude_statuses = 5;
   */
  excludeStatuses: string[];

  /**
   * @generated from field: bool explain = 6;
   */
  explain: boolean;
};

/**
 * Describes the message amrec.v1.RecommendForUserRequest.
 * Use `create(RecommendForUserRequestSchema)` to create a new message.
 */
export const RecommendForUserRequestSchema: GenMessage<RecommendForUserRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 5);

/**
 * @generated from message amrec.v1.RecommendForUserResponse
 */
export type RecommendForUserResponse = Message<"amrec.v1.RecommendForUserResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.Recommendation recommendations = 1;
   */
  recommendations: Recommendation[];
};

/**
 * Describes the message amrec.v1.RecommendForUserResponse.
 * Use `create(RecommendForUserResponseSchema)` to create a new message.
 */
export const RecommendForUserResponseSchema: GenMessage<RecommendForUserResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 6);

/**
 * ImportListRequest pulls a public list from MAL or AniList by username. Both
 * expose public lists without OAuth, so no credentials are needed for the
 * read-only import.
 *
 * @generated from message amrec.v1.ImportListRequest
 */
export type ImportListRequest = Message<"amrec.v1.ImportListRequest"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * Reuse the existing profile rather than creating a second one.
   *
   * @generated from field: string profile_id = 3;
   */
  profileId: string;
};

/**
 * Describes the message amrec.v1.ImportListRequest.
 * Use `create(ImportListRequestSchema)` to create a new message.
 */
export const ImportListRequestSchema: GenMessage<ImportListRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 7);

/**
 * @generated from message amrec.v1.ImportListResponse
 */
export type ImportListResponse = Message<"amrec.v1.ImportListResponse"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: int32 entries_imported = 2;
   */
  entriesImported: number;

  /**
   * Entries whose upstream ID isn't in our catalog yet. Non-zero is normal
   * before a full backfill; they're enqueued for crawl rather than dropped.
   *
   * @generated from field: int32 entries_unresolved = 3;
   */
  entriesUnresolved: number;
};

/**
 * Describes the message amrec.v1.ImportListResponse.
 * Use `create(ImportListResponseSchema)` to create a new message.
 */
export const ImportListResponseSchema: GenMessage<ImportListResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 8);

/**
 * EvaluateRequest runs the offline eval: hold out a slice of a profile's
 * rated titles, rank the catalog, and report where the held-out items landed.
 * This is what makes weight tuning empirical rather than vibes.
 *
 * @generated from message amrec.v1.EvaluateRequest
 */
export type EvaluateRequest = Message<"amrec.v1.EvaluateRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: amrec.v1.SignalWeights weights = 2;
   */
  weights?: SignalWeights | undefined;

  /**
   * default 0.2
   *
   * @generated from field: double holdout_frac = 3;
   */
  holdoutFrac: number;

  /**
   * fixed seed = reproducible comparisons
   *
   * @generated from field: int32 seed = 4;
   */
  seed: number;
};

/**
 * Describes the message amrec.v1.EvaluateRequest.
 * Use `create(EvaluateRequestSchema)` to create a new message.
 */
export const EvaluateRequestSchema: GenMessage<EvaluateRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 9);

/**
 * @generated from message amrec.v1.EvaluateResponse
 */
export type EvaluateResponse = Message<"amrec.v1.EvaluateResponse"> & {
  /**
   * @generated from field: double ndcg_at_10 = 1;
   */
  ndcgAt10: number;

  /**
   * @generated from field: double recall_at_50 = 2;
   */
  recallAt50: number;

  /**
   * @generated from field: double mean_reciprocal_rank = 3;
   */
  meanReciprocalRank: number;

  /**
   * @generated from field: int32 holdout_size = 4;
   */
  holdoutSize: number;

  /**
   * Per-signal ablation: score with that signal zeroed, so you can see which
   * ones are actually earning their weight.
   *
   * @generated from field: map<string, double> ablation_ndcg = 5;
   */
  ablationNdcg: { [key: string]: number };
};

/**
 * Describes the message amrec.v1.EvaluateResponse.
 * Use `create(EvaluateResponseSchema)` to create a new message.
 */
export const EvaluateResponseSchema: GenMessage<EvaluateResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_recommend, 10);

/**
 * SignalKind enumerates the scorers. Adding one here plus a weight is the
 * intended way to extend the recommender.
 *
 * @generated from enum amrec.v1.SignalKind
 */
export enum SignalKind {
  /**
   * @generated from enum value: SIGNAL_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * cosine over rank-weighted tag vectors
   *
   * @generated from enum value: SIGNAL_KIND_TAG_SIMILARITY = 1;
   */
  TAG_SIMILARITY = 1,

  /**
   * synopsis/tag embedding kNN
   *
   * @generated from enum value: SIGNAL_KIND_TEXT_EMBEDDING = 2;
   */
  TEXT_EMBEDDING = 2,

  /**
   * cover-art visual similarity
   *
   * @generated from enum value: SIGNAL_KIND_IMAGE_EMBEDDING = 3;
   */
  IMAGE_EMBEDDING = 3,

  /**
   * MAL/AniList user "if you liked X" edges
   *
   * @generated from enum value: SIGNAL_KIND_CO_RECOMMENDED = 4;
   */
  CO_RECOMMENDED = 4,

  /**
   * proximity in the sequel/adaptation graph
   *
   * @generated from enum value: SIGNAL_KIND_RELATION_GRAPH = 5;
   */
  RELATION_GRAPH = 5,

  /**
   * same author/director/studio
   *
   * @generated from enum value: SIGNAL_KIND_SHARED_CREDITS = 6;
   */
  SHARED_CREDITS = 6,

  /**
   * prior, not similarity — keeps the tail sane
   *
   * @generated from enum value: SIGNAL_KIND_POPULARITY = 7;
   */
  POPULARITY = 7,

  /**
   * Mood is NOT a subset of tags. The UI's "Vibe match" preset weights mood
   * 0.46 against genre 0.26 — collapsing them into TAG_SIMILARITY would make
   * that preset unexpressible. Sourced from tags whose category is "mood".
   *
   * @generated from enum value: SIGNAL_KIND_MOOD_SIMILARITY = 8;
   */
  MOOD_SIMILARITY = 8,

  /**
   * Aggregate critical score. Distinct from POPULARITY: a 9.0-rated show with
   * 30k members and a 7.5-rated one with 2M members are opposite signals, and
   * the "Crowd favourites" preset deliberately weights both.
   *
   * @generated from enum value: SIGNAL_KIND_SCORE = 9;
   */
  SCORE = 9,

  /**
   * Inverse popularity, as a first-class signal rather than a negated weight.
   * "Deep cuts" wants to *reward* obscurity, and a negative POPULARITY weight
   * would break the normalize-by-weight-sum blend.
   *
   * @generated from enum value: SIGNAL_KIND_OBSCURITY = 10;
   */
  OBSCURITY = 10,

  /**
   * How close the runtime/length is to the seed's — a 12-episode viewer and a
   * 148-episode viewer want different things from the same genre.
   *
   * @generated from enum value: SIGNAL_KIND_LENGTH_FIT = 11;
   */
  LENGTH_FIT = 11,
}

/**
 * Describes the enum amrec.v1.SignalKind.
 */
export const SignalKindSchema: GenEnum<SignalKind> = /*@__PURE__*/
  enumDesc(file_amrec_v1_recommend, 0);

/**
 * @generated from service amrec.v1.RecommendService
 */
export const RecommendService: GenService<{
  /**
   * @generated from rpc amrec.v1.RecommendService.RecommendSimilar
   */
  recommendSimilar: {
    methodKind: "unary";
    input: typeof RecommendSimilarRequestSchema;
    output: typeof RecommendSimilarResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.RecommendService.RecommendForUser
   */
  recommendForUser: {
    methodKind: "unary";
    input: typeof RecommendForUserRequestSchema;
    output: typeof RecommendForUserResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.RecommendService.ImportList
   */
  importList: {
    methodKind: "unary";
    input: typeof ImportListRequestSchema;
    output: typeof ImportListResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.RecommendService.Evaluate
   */
  evaluate: {
    methodKind: "unary";
    input: typeof EvaluateRequestSchema;
    output: typeof EvaluateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_amrec_v1_recommend, 0);

